import * as React from "react";
import { forwardRef } from "react";
const SvgAdGroupPolicy = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "#0078D4", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }), /* @__PURE__ */ React.createElement("path", { d: "M14 2v6h6M8 13h8m-8 4h6" }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 1, fill: "#0078D4" }));
const ForwardRef = forwardRef(SvgAdGroupPolicy);
export default ForwardRef;
